export const shiftHistoryList = [
  {
    "id": "00002",
    "Responsible": "supervisor",
    "Shift_active": "No",
    "Start_date": "16/12/2019",
    "Start_time": "15:28:00",
    "End_date":  "16/12/2019",
    "End_time": "16:28:56",
    "Shift_resp_area_key": "",
    "Shift_type_key": ""
  },
  {
    "id": "00003",
    "Responsible": "bfl",
    "Shift_active": "No",
    "Start_date": "16/01/2018",
    "Start_time": "16:29:29",
    "End_date": "29/01/2025",
    "End_time": "17:43:25",
    "Shift_resp_area_key": "",
    "Shift_type_key": ""
  },
  {
    "id": "00004",
    "Responsible": "supervisor",
    "Shift_active": "No",
    "Start_date": "19/01/2020",
    "Start_time": "17:50:39",
    "End_date": "",
    "End_time": "",
    "Shift_resp_area_key": "",
    "Shift_type_key": ""
  },
  {
    "id": "00005",
    "Responsible": "bfl",
    "Shift_active": "Yes",
    "Start_date": "30/01/2020",
    "Start_time": "07:36:00",
    "End_date": "",
    "End_time": "",
    "Shift_resp_area_key": "",
    "Shift_type_key": ""
  }
];
